let ctx: AudioContext | null = null;
let unlocked = false;

const MUTE_KEY = 'cardtoys:muted';
let muted = (() => {
  try { return localStorage.getItem(MUTE_KEY) === '1'; } catch { return false; }
})();

export function isMuted(): boolean {
  return muted;
}

export function setMuted(value: boolean): void {
  muted = value;
  try { localStorage.setItem(MUTE_KEY, value ? '1' : '0'); } catch { /* storage off */ }
}

function getCtx(): AudioContext {
  if (!ctx) ctx = new AudioContext();
  return ctx;
}

export function unlockAudio(): void {
  if (unlocked) return;
  const c = getCtx();
  if (c.state === 'suspended') void c.resume();
  unlocked = true;
}

function noiseBuffer(durationSec: number): AudioBuffer {
  const c = getCtx();
  const len = Math.floor(c.sampleRate * durationSec);
  const buf = c.createBuffer(1, len, c.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < len; i++) data[i] = Math.random() * 2 - 1;
  return buf;
}

function tick(freqHz: number, gainPeak: number, durationSec: number) {
  const c = getCtx();
  const now = c.currentTime;
  const src = c.createBufferSource();
  src.buffer = noiseBuffer(durationSec);
  const filt = c.createBiquadFilter();
  filt.type = 'bandpass';
  filt.Q.value = 0.7;
  filt.frequency.value = freqHz;
  const gain = c.createGain();
  gain.gain.setValueAtTime(0.0, now);
  gain.gain.linearRampToValueAtTime(gainPeak, now + 0.0015);
  gain.gain.exponentialRampToValueAtTime(0.001, now + durationSec);
  src.connect(filt).connect(gain).connect(c.destination);
  src.start(now);
}

export function playFlip(): void {
  if (!unlocked || muted) return;
  tick(2400, 0.013, 0.025);
}

export function playPlace(): void {
  if (!unlocked || muted) return;
  tick(1500, 0.024, 0.035);
}

export function playShuffle(): void {
  if (!unlocked || muted) return;
  for (let i = 0; i < 4; i++) {
    setTimeout(() => playFlip(), i * 110 + Math.random() * 40);
  }
}
